import ImpersonateUser from './ImpersonateUser';
import enhanceAndHideIfUserNotConnected, { enhance } from './ImpersonateUserContainer';

// this one checks if user is connected and if not it hides the component
export default enhanceAndHideIfUserNotConnected(ImpersonateUser);

// this one doesn't check if user is connected and trusts that it is
export const ImporsonateValidUser = enhance(ImpersonateUser);
